import React, { useState, useEffect, useCallback } from "react";

import TopAlert from "../../components/TopNotification/TopAlert";
import PrivateTagAvatar from "../../components/PrivateTagAvatar";
import SearchDropDown from "../SearchSkillListing/components/LocationFilter/SearchDropDown";
import { LoadingOutlined, RightOutlined } from "@ant-design/icons";
import _ from "lodash";
import {
Button,
Row,
Rate,
Dropdown,
Space,
DatePicker,
Col,
Table,
Menu,
Drawer,
Radio,
Divider,
Pagination,
Select,
Checkbox,
Spin,
Input } from
"antd";
import emptyjobs from "../../assets/img/Emptyjobs.png";
import filterIcon from "../../assets/img/filtericon.svg";
import messageIcon from "../../assets/icons/message.svg";
import starIcon from "../../assets/icons/Star233x.png";
import history from "../../routes/history";
import {
getFullName,
getQuery,
isNull,
negativeBidStatus, isNonHC } from
"./../../shared/helpers";
import { Tooltip } from "antd";
import {
getCandidateCount,
getCandidates,
fetchHRMS,
resetMessageFavorites,
addMessageToFavourite,
removeMessageFromFavourite,
resetChatHistory,
getHRMDetailInit,
absDetailInit,
configTimeSheetInit,
resetHeader,
configTimeSheet,
fetchVmsRequest,
fetchFacilityRequest } from
"../../redux/actions";
import Loader from "../../components/Loading/Loader";
import { getImage } from "../../utilities/storageOperations/downloadURL";
import { useDispatch, useSelector } from "react-redux";
import FeatureGate from "../FeatureGate/FeatureGate";
import { DownOutlined, SearchOutlined, CloseOutlined } from "@ant-design/icons";
import CustomDropdown from "./components/CustomDropdown";
import CustomModal from "./components/CustomModal";
import moment from "moment";
import { defaultImage } from "../../BaseUrls/DefaultURls";
import { useLocation, useHistory } from "react-router-dom";
import { DefaultRating } from "../../assets/helpers";
import { AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import { formatPhoneNumber } from "../../shared/helpers";
import PrivateGigsTag from "../SearchSkillListing/components/AllGigs/PrivateGigsTag";
import PrivateGigsTagNodification from "../../components/Notification/components/PrivateGigsTagNodification";
import ABSFilter from "../../components/ABSFilter/ABSFilter";
import PlacedAndReceived from "../../components/PlacedAndReceived/PlacedAndReceived";
import { TIME_SHEET_MENU_OPTIONS } from "../../shared/constants";
import TimeSheetButton from "./components/TimeSheetButton/TimeSheetButton";
import { TIME_OF_REQUEST } from "../ManageTimeSheet/TimeSheetConstants";
import { canUseSubscriptionFeatures } from "../../shared/billing";
import "./ManageCandidate.css";
const { RangePicker } = DatePicker;

const BID_TYPE_RECEIVED = "Received";

const detailsPage = (bidData) => {
  try {
    if (bidData?.bidType == BID_TYPE_RECEIVED) {
      history.push({
        pathname: "/candidateskilllisting",
        state: {
          id: bidData?.received?.ProfileId || bidData?.ProfileId,
          fname: bidData?.user?.Profiles?.FirstName,
          lname: bidData?.user?.Profiles?.LastName
        }
      });
    } else {
      history.push(`/internal-detail/${bidData.SkillListings.SkillListingId}`);
    }
  } catch (error) {}
};

const Image = ({ url, mobile }) => {
  const [profilePic, setProfilePic] = useState("");
  const [imageError, setImageError] = useState(false);

  useEffect(async () => {
    let profilePic = "";
    if (url) {
      profilePic = `${process.env.REACT_APP_S3_URL}${url?.charAt(0) !== "/" ? "/" : ""
      }${url}`;
    }

    setProfilePic(profilePic);
  }, [url]);

  if (mobile) {
    return (
      <img
      className="Manage-candidate-image-circle-mobile"
      src={profilePic}
      alt="candidate image"
      onError={({ currentTarget }) => {
        currentTarget.onError = null;
        currentTarget.src = defaultImage;
      }} />);


  } else {
    return (
      <img
      className="Manage-candidate-image-circle"
      src={profilePic}
      alt="candidate image"
      onError={({ currentTarget }) => {
        currentTarget.onError = null;
        currentTarget.src = defaultImage;
      }} />);


  }
};

export default function ManageCandidate() {
  const dispatch = useDispatch();
  const ABS = useSelector((state) => state.profileReducer.ABS);
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const planCode = creditsBalance?.data?.planCode || '';
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures(userProfile);
  const isRestrictedPlan = subscriptionFeaturesEnabled && ['Free', 'STARTER_MONTHLY', 'STARTER_YEARLY'].includes(planCode);
  const isPlanExpired = subscriptionFeaturesEnabled && creditsBalance?.data?.status === 'expired';
  const currentUserEmail = userProfile?.EmailAddress;

  const isAdmin =
  Array.isArray(ABS) &&
  ABS.every((val) => val.AMEmail === currentUserEmail);

  const isAbs = !isAdmin && ABS.length > 0;
  const loading = useSelector((state) => state.getCandidatesReducer.loading);
  const isfavorite = useSelector(
  (state) => state.messageFavouriteReducer.loading);

  var favourite_status = useSelector(
  (state) => state.messageFavouriteReducer.fav_status);

  const vms = useSelector((state) => state.vmsFilterReducer?.data);
  const facilities = useSelector((state) => state.VmsFacilityReducer?.data);
  const favLoading = useSelector(
  (state) => state.oneUserskillListingReducer.loading);


  const hireLoading = useSelector(
  (state) => state.messagesReducer.historyLoading);

  const bid_types_count = useSelector(
  (state) => state.getCandidatesCountsReducer.bid_types_count);

  const all_bids_status = useSelector(
  (state) => state.getCandidatesCountsReducer.all_bids_status);

  const allBids = useSelector((state) => state.getCandidatesReducer.allBids);
  const receivedBids = useSelector(
  (state) => state.getCandidatesReducer.receivedBids);

  const placedBids = useSelector(
  (state) => state.getCandidatesReducer.placedBids);

  const favouriteBids = useSelector(
  (state) => state.getCandidatesReducer.favouriteBids);

  const update_bid_success = useSelector(
  (state) => state.updateBidReducers.success);

  const update_proposal_success = useSelector(
  (state) => state.updateProposalReducers.success);

  const retract_bid_success = useSelector(
  (state) => state.retractBidReducers.success);

  const create_interview_success = useSelector(
  (state) => state.createInterviewReducer.success);

  const update_interview_success = useSelector(
  (state) => state.updateInterviewReducer.success);

  const make_offer_success = useSelector(
  (state) => state.messagesReducer.makeOfferRes);

  const edit_offer_success = useSelector(
  (state) => state.messagesReducer.editOfferRes);

  const HRMs = useSelector((state) => state.messagesReducer.Hrms);
  const count_Success = useSelector(
  (state) => state.getCandidatesCountsReducer.response);

  const url = useLocation();
  const [tableData, setTableData] = useState([]);
  const [tableDataOriginal, setTableDataOriginal] = useState([]);
  const [searchText, setSearchText] = useState(
  getQuery("searchTerm") ? getQuery("searchTerm") : "");

  const [seeMore, setSeeMore] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [dateFocussed, setDateFocussed] = useState(false);
  const [vmsDropdownOpen, setVmsDropdownOpen] = useState(false);
  const [facilityDropdownOpen, setFacilityDropdownOpen] = useState(false);
  const [tempSelectedVms, setTempSelectedVms] = useState([]);
  const [tempSelectedFacilities, setTempSelectedFacilities] = useState([]);
  const [facilitySearchText, setFacilitySearchText] = useState('');
  const [selectedVms, setSelectedVms] = useState(() => {
    const vmsQuery = getQuery("vmsTypes");
    return vmsQuery ? vmsQuery.split(',') : [];
  });
  const [selectedFacilities, setSelectedFacilities] = useState(() => {
    const facQuery = getQuery("facilityTypes");
    return facQuery ? facQuery.split(',') : [];
  });
  const [bidTypeName, setBidTypeName] = useState(
  url.search && url?.search != "" && url?.search.includes("type") ?
  url?.search.split("type")[1].split("&")[0].replace("=", "").toString() :
  "All_Bids");

  const [bidStatusName, setBidStatusName] = useState(
  url.search && url?.search != "" && url?.search.includes("stage") ?
  url?.search.split("stage")[1].split("&")[0].replace("=", "").toString() :
  "All");

  const [candidateType, setCandidateType] = useState(
  getQuery("bidType") || "all");

  const [bidStatusRadioValue, setBidStatusRadioValue] = useState("null");
  const [visibleStatusDrawer, setVisibleStatusDrawer] = React.useState();
  const [bidTypeFilterValue, setBidTypeFilterValue] = useState(1);
  const [bidStatusFilterValue, setBidStatusFilterValue] = useState(18);
  const [inputWidth, setInputWidth] = useState();
  const [Dimensions, setDimensions] = useState(getWindowDimensions());
  const [dataArrayMobileOriginal, setDataArrayMobileOriginal] = useState([]);
  const [dataArrayMobile, setDataArrayMobile] = useState([]);
  const [favorite, setFavorite] = React.useState(false);
  const [startDate, setStartDate] = useState(
  url.search && url?.search != "" && url?.search.includes("StartDate") ?
  url?.search.
  split("StartDate")[1].
  split("&")[0].
  replace("=", "").
  replace("%3A", ":").
  replace("%3A", ":").
  toString() :
  "");

  const [endDate, setEndDate] = useState(
  url.search && url?.search != "" && url?.search.includes("EndDate") ?
  url?.search.
  split("EndDate")[1].
  split("&")[0].
  replace("=", "").
  replace("%3A", ":").
  replace("%3A", ":").
  toString() :
  "");

  const [page, setPage] = useState(
  url.search && url?.search != "" && url?.search.includes("page") ?
  parseInt(url?.search.split("page")[1].split("&")[0].replace("=", "")) :
  1);

  const [perPage, setPerPage] = useState(10);
  const profile = JSON.parse(localStorage.getItem("userProfile"));
  const getAbsDetails = () => {
    if (isAbs)
    return {
      name: getFullName(
      profile?.Profiles?.FirstName,
      profile?.Profiles?.LastName),

      id: profile?.AccountId
    };else

    return {
      name: null,
      id: null
    };
  };

  const isNullString = (value) => {
    return ["null", "undefined", undefined, null, ""].includes(value);
  };
  const [HrmId, setHrmId] = useState(
  getQuery("HRM") ?
  !isNullString(getQuery("HRM")) ?
  getQuery("HRM") :
  null :
  null);

  const [absId, setAbsId] = useState(
  isAbs ?
  getAbsDetails().id :
  getQuery("absId") ?
  !isNullString(getQuery("absId")) ?
  getQuery("absId") :
  null :
  null);

  const [HrmName, setHrmName] = useState(
  getQuery("hrmName") ?
  !isNullString(getQuery("hrmName")) ?
  getQuery("hrmName") :
  null :
  null);

  const [timeSheetType, setTimeSheetType] = useState(
  getQuery("timeSheetType") ?
  !isNullString(getQuery("timeSheetType")) ?
  getQuery("timeSheetType") :
  "all" :
  "all");


  const [absName, setAbsName] = useState(
  isAbs ?
  getAbsDetails().name :
  getQuery("absName") ?
  !isNullString(getQuery("absName")) ?
  getQuery("absName") :
  null :
  null);


  const details = HRMs.map((item) => {
    return getItem(
    item?.Profiles?.FirstName ?
    item?.Profiles?.FirstName + " " + item?.Profiles?.LastName :
    item?.UserName,
    item?.AccountId,
    item?.AccountId,
    item?.profile?.MobilePhone);

  });
  function getItem(label, value, key, icon, children, type) {
    return {
      value,
      icon,
      key,
      children,
      label,
      type
    };
  }
  const [result, setResult] = useState();
  const [tableBidType, setTableBidType] = useState();
  const handleDebounceFacilitySearch = useCallback(
  _.debounce((query) => {
    const vmsPayload = tempSelectedVms.length > 0 ? tempSelectedVms : null; // Null = all VMS
    if (!query) {
      const payload = { vms: vmsPayload };
      dispatch(fetchFacilityRequest(payload));
      return;
    }
    const params = {
      vms: vmsPayload,
      search: query
    };
    dispatch(fetchFacilityRequest(params));
  }, 500),
  [dispatch, tempSelectedVms]);

  const getVmsDisplayNames = (names) => {
    if (!names || names.length === 0) return "Select VMS";
    const limit = 2;

    if (names.length > limit) {
      const displayText = `${names.slice(0, limit).join(", ")} +${names.length - limit}`;
      return (
        <Tooltip title={names.join(", ")}>
          <span>{displayText}</span>
        </Tooltip>);

    }

    return names.join(", ");
  };
  const getFacilityDisplayNames = (ids) => {
    if (!facilities || !ids || ids.length === 0) return "Select Facility";

    const names = ids.
    map((id) => {
      const facility = facilities.find((item) => item._id === id);
      return facility ? facility.FacilityName : null;
    }).
    filter(Boolean);

    if (names.length === 0) return "Select Facility";

    const nameLimit = 1;
    const charLimit = 15;

    const limitedNames = names.slice(0, nameLimit).map((name) => {
      if (name.length > charLimit) {
        return name.slice(0, charLimit) + "...";
      }
      return name;
    });

    const extraCount = names.length - nameLimit;

    if (extraCount > 0) {
      const displayText = `${limitedNames.join(", ")} +${extraCount}`;
      return (
        <Tooltip title={names.join(", ")}>
          <span>{displayText}</span>
        </Tooltip>);

    }

    return limitedNames.join(", ");
  };
  const handleMessageClick = (bidData) => {
    if (bidData?.ConversationId) {
      history.push({
        pathname: "/conversations",
        state: {
          openConvo: true,
          conversationId: bidData?.ConversationId
        }
      });
    }
  };

  const addQuery = (key, value) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    history.replace({
      search: searchParams.toString()
    });
    // new URLSearchParams(searchParams.toString())
  };

  const removeQuery = (key) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(key);
    history.push({
      search: searchParams.toString()
    });
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleVmsToggle = (name) => {
    setTempSelectedVms((prev) =>
    prev.includes(name) ?
    prev.filter((item) => item !== name) :
    [...prev, name]);

  };
  useEffect(() => {
    if (tempSelectedVms?.length > 0) {
      const payload = {
        vms: tempSelectedVms
      };
      dispatch(fetchFacilityRequest(payload));
    }
  }, [tempSelectedVms, dispatch]);
  useEffect(() => {
    setTimeout(() => {
      favourite_status = false;
    }, 5000);
  }, [favourite_status]);

  useEffect(() => {
    if (tableData?.length != 0) {
      addQuery("page", page);
      dispatch(
      getCandidateCount({
        bid_type_name: bidTypeName,
        startdate: startDate,
        enddate: endDate,
        ABSId: absId,
        id: HrmId,
        bidType: candidateType,
        searchTerm: searchText,
        timeSheetType,
        vmsTypes: selectedVms.join(','),
        facilityTypes: selectedFacilities.join(',')
      }));

      dispatch(
      getCandidates({
        bid_type_name: bidTypeName,
        bid_status_name: bidStatusName,
        startdate: startDate,
        enddate: endDate,
        page: page,
        perPage: perPage,
        ABSId: absId,
        id: HrmId,
        bidType: candidateType,
        searchTerm: searchText,
        timeSheetType,
        vmsTypes: selectedVms.join(','),
        facilityTypes: selectedFacilities.join(',')
      }));

    }
  }, [page]);

  useEffect(() => {
    dispatch(resetMessageFavorites());
    dispatch(absDetailInit());
    dispatch(getHRMDetailInit());
    dispatch(fetchHRMS(profile));
    dispatch(
    getCandidateCount({
      bid_type_name: getQuery("bidTypeName") || bidTypeName,
      startdate: getQuery("StartDate") || startDate,
      enddate: getQuery("EndDate") || endDate,
      bidType: getQuery("bidType") || candidateType,
      searchTerm: getQuery("searchTerm") || searchText,
      ABSId: isAbs ?
      getAbsDetails().id :
      getQuery("absId") ?
      !isNullString(getQuery("absId")) ?
      getQuery("absId") :
      null :
      null,
      id: getQuery("HRM") ?
      !isNullString(getQuery("HRM")) ?
      getQuery("HRM") :
      null :
      null,
      timeSheetType,
      vmsTypes: getQuery("vmsTypes") || '',
      facilityTypes: getQuery("facilityTypes") || ''
    }));


    dispatch(
    getCandidates({
      bid_type_name: getQuery("type") || bidTypeName,
      bid_status_name: getQuery("stage") || bidStatusName,
      startdate: getQuery("StartDate") || startDate,
      enddate: getQuery("EndDate") || endDate,
      page: getQuery("page") || page,
      perPage: perPage,
      ABSId: isAbs ?
      getAbsDetails().id :
      getQuery("absId") ?
      !isNullString(getQuery("absId")) ?
      getQuery("absId") :
      null :
      null,
      id: getQuery("HRM") ?
      !isNullString(getQuery("HRM")) ?
      getQuery("HRM") :
      null :
      null,
      bidType: candidateType || getQuery("bidType"),
      searchTerm: searchText || getQuery("searchTerm"),
      timeSheetType,
      vmsTypes: selectedVms.join(',') || getQuery("vmsTypes"), // Fixed: Consistent
      facilityTypes: selectedFacilities.join(',') || getQuery("facilityTypes") // Fixed: Consistent
    }));


    function handleResize() {
      setDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setAbsName(
    isAbs ?
    getAbsDetails().name :
    getQuery("absName") ?
    !isNullString(getQuery("absName")) ?
    getQuery("absName") :
    null :
    null);

    setAbsId(
    isAbs ?
    getAbsDetails().id :
    getQuery("absId") ?
    !isNullString(getQuery("absId")) ?
    getQuery("absId") :
    null :
    null);


    applyBidsFilters(
    getQuery("type") || bidTypeName,
    getQuery("stage") || bidStatusName,
    getQuery("HRM") ?
    !isNullString(getQuery("HRM")) ?
    getQuery("HRM") :
    null :
    null,
    getQuery("StartDate") || startDate,
    getQuery("EndDate") || endDate,
    getQuery("bidType") || candidateType,
    getQuery("searchTerm") || searchText,
    isAbs ?
    getAbsDetails().id :
    getQuery("absId") ?
    !isNullString(getQuery("absId")) ?
    getQuery("absId") :
    null :
    null);

  }, [ABS]);

  const handleFacilityToggle = (id) => {
    setTempSelectedFacilities((prev) =>
    prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]);

  };
  const handleVmsApply = () => {
    setSelectedVms(tempSelectedVms);


    applyBidsFilters(
    bidTypeName,
    bidStatusName,
    HrmId,
    startDate,
    endDate,
    candidateType,
    searchText,
    absId,
    timeSheetType,
    tempSelectedVms,
    selectedFacilities);


    setVmsDropdownOpen(false);
  };


  const handleFacilityApply = () => {
    setSelectedFacilities(tempSelectedFacilities);
    addQuery("facilityTypes", tempSelectedFacilities.join(','));
    applyBidsFilters(
    bidTypeName, bidStatusName, HrmId, startDate, endDate, candidateType, searchText, absId, timeSheetType,
    selectedVms,
    tempSelectedFacilities);

    setFacilityDropdownOpen(false);
  };

  const handleVmsClear = () => {
    setTempSelectedVms([]);
    setSelectedVms([]);
    removeQuery("vmsTypes");
    applyBidsFilters(
    bidTypeName, bidStatusName, HrmId, startDate, endDate, candidateType, searchText, absId, timeSheetType,
    []);

  };
  const handleFacilityClear = () => {
    setTempSelectedFacilities([]);
    setSelectedFacilities([]);
    removeQuery("facilityTypes");
    setFacilitySearchText('');
    applyBidsFilters(
    bidTypeName, bidStatusName, HrmId, startDate, endDate, candidateType, searchText, absId, timeSheetType,
    selectedVms,
    []);

  };
  const vmsMenu =
  <Menu style={{ border: "solid 1px #dedede", padding: 8 }}>
      <div style={{ maxHeight: 200, overflowY: "auto" }}>
        {vms && vms.length > 0 ?
      vms.map((item) =>
      <Menu.Item key={item.VMSName}>
              <Checkbox
        checked={tempSelectedVms.includes(item.VMSName)}
        onChange={() => handleVmsToggle(item.VMSName)}>
          
                {item.VMSName}
              </Checkbox>
            </Menu.Item>) :


      <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 100
      }}>
        
            <Spin size="small" tip="Loading VMS..." />
          </div>}
      
      </div>

      <div
    style={{
      borderTop: "1px solid #e8e8e8",
      marginTop: 8,
      paddingTop: 8,
      display: "flex",
      justifyContent: "space-between"
    }}>
      
        <Button size="small" onClick={handleVmsClear}>
          Clear
        </Button>
        <Button type="primary" size="small" onClick={handleVmsApply}>
          Apply
        </Button>
      </div>
    </Menu>;


  const facilityMenu =
  <Menu style={{ border: "solid 1px #dedede", padding: 8 }}>
      <Input.Search
    placeholder="Search facilities"
    className="facility-search-input"
    size="small"
    value={facilitySearchText}
    onChange={(e) => {
      const query = e.target.value;
      setFacilitySearchText(query);
      handleDebounceFacilitySearch(query);
    }}
    allowClear
    onClear={() => {
      setFacilitySearchText('');
      handleDebounceFacilitySearch('');
    }}
    style={{ marginBottom: 8, width: '100%' }} />
    
      <div style={{ maxHeight: 200, overflowY: "auto" }}>
        {facilities && facilities.length > 0 ?
      facilities.map((item) =>
      <Menu.Item key={item._id}>
              <Checkbox
        checked={tempSelectedFacilities.includes(item._id)}
        onChange={() => handleFacilityToggle(item._id)}>
          
                {item.FacilityName}
              </Checkbox>
            </Menu.Item>) :


      <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 100
      }}>
        
            <Spin size="small" tip="Loading Facilities..." />
          </div>}
      
      </div>

      <div
    style={{
      borderTop: "1px solid #e8e8e8",
      marginTop: 8,
      paddingTop: 8,
      display: "flex",
      justifyContent: "space-between"
    }}>
      
        <Button size="small" onClick={handleFacilityClear}>
          Clear
        </Button>
        <Button type="primary" size="small" onClick={handleFacilityApply}>
          Apply
        </Button>
      </div>
    </Menu>;


  useEffect(() => {
    if (vmsDropdownOpen && (!vms || vms.length === 0)) {
      dispatch(fetchVmsRequest());
    }
  }, [vmsDropdownOpen, vms, dispatch]);
  useEffect(() => {
    if (facilityDropdownOpen && (!facilities || facilities.length === 0)) {
      const payload = { vms: tempSelectedVms || [] };
      dispatch(fetchFacilityRequest(payload));
    }
  }, [facilityDropdownOpen, facilities, tempSelectedVms, dispatch]);
  const resultHandler = () => {
    setResult(
    bidStatusName == "All" ?
    all_bids_status.reduce((acc, item) => acc + item.count, 0) :
    bidStatusName == "New_Bid" ?
    all_bids_status[0]?.count :
    bidStatusName == "Accepted_Bids" ?
    all_bids_status[1]?.count :
    bidStatusName == "Declined_Bids" ?
    all_bids_status[2]?.count :
    bidStatusName == "Retracted" ?
    all_bids_status[16]?.count :
    bidStatusName == "Profile_Submitted" ?
    all_bids_status[3]?.count :
    bidStatusName == "Interview_Proposed" ?
    all_bids_status[4]?.count :
    bidStatusName == "Interview_Accepted" ?
    all_bids_status[5]?.count :
    bidStatusName == "Interview_Cancelled" ?
    all_bids_status[6]?.count :
    bidStatusName == "Offer_Sent" ?
    all_bids_status[7]?.count :
    bidStatusName == "Offer_Accepted" ?
    all_bids_status[8]?.count :
    bidStatusName == "Offer_Declined" ?
    all_bids_status[9]?.count :
    bidStatusName == "Hired" ?
    all_bids_status[10]?.count :
    bidStatusName == "On_Billing" ?
    all_bids_status[11]?.count :
    bidStatusName == "Billing_Extended" ?
    all_bids_status[13]?.count :
    bidStatusName == "Off_Billing" ?
    all_bids_status[12]?.count :
    bidStatusName == "Terminated" ?
    all_bids_status[15]?.count :
    bidStatusName == "Cancelled" ?
    all_bids_status[14]?.count :
    0);


    bidTypeName == "Received_Bid" ?
    setTableBidType("Bid Date") :
    setTableBidType("Bid Date");
  };
  const onChange = (filters, sorter, extra) => {};

  // table columns
  const isPrivate = (id) => {
    let { EmployeeAssociation = [] } = JSON.parse(
    localStorage.getItem("userProfile"));

    return EmployeeAssociation.includes(id);
  };

  const handleConfigTimeSheetClick = (data) => {
    try {
      // dispatch(resetHeader());
      dispatch(
      configTimeSheet({
        GigId: data?.gigs?._id,
        SkillListingId: data?.SkillListings?._id,
        TalentAccountId: data?.user?.AccountId,
        BidId: data?.BidId,
        ProposalId: data?.ProposalId || data?.received?.ProposalId
      }));

      history.push("/start-date");
    } catch (error) {}
  };

  const handleViewTimeSheet = (data) => {
    try {
      history.push(`/manage-timesheet/${data?.configureTimeSheetId}`);
    } catch (error) {}
  };

  const handleTimeOff = (data) => {
    try {
      history.push(
      `/manage-timesheet/${data?.configureTimeSheetId}?tab=${TIME_OF_REQUEST}`);

    } catch (error) {}
  };

  const columns = [
  {
    title: "Candidate Details",
    dataIndex: "cdetails",
    render: ({
      rate,
      image,
      title,
      candidateName,
      phoneNumber,
      rating,
      reviews,
      bidData,
      type
    }) => {
      return (
        <>
            <div
          className="candidateDetailsContainer"
          onClick={(e) => {
            e.stopPropagation();
            detailsPage(bidData);
          }}>
            
              <p
            className="star"
            onClick={(e) => {
              e.stopPropagation();
            }}>
              
                {rate}
              </p>
              {image != "" && image?.split("/")?.pop() !== "no-pic.png" ?
            <div style={{ position: "relative" }}>
                  <Image url={image} />
                  {isPrivate(
              bidData?.user?.AccountId ||
              bidData?.SkillListings?.CreatedBy) &&

              <PrivateTagAvatar
              isMobileView={Dimensions < 769}
              size={"small"} />}

              
                </div> :

            <div className="image-circle-filled">
                  {bidData?.SkillListings ?
              candidateName.charAt(0).toUpperCase() == undefined ?
              "" :
              candidateName.charAt(0).toUpperCase() :
              title.charAt(0).toUpperCase() == undefined ?
              "" :
              title.charAt(0).toUpperCase()}
                  {isPrivate(bidData?.SkillListings?.CreatedBy || bidData?.user?.AccountId) &&
              <PrivateTagAvatar
              isMobileView={Dimensions < 769}
              size={"small"} />}

              
                </div>}
            
              <div className="cdetails">
                <p
              className={"listingTitle"}
              style={
              bidData?.received ?
              { color: "#4054b2" } :
              { color: "#4054b2" }}>

                
                  <p className={"listingTitle"} style={{ color: "#4054b2" }}>
                    <Tooltip
                  title={
                  title?.length > 100 ?
                  `${title.slice(0, 100)}...` :
                  title}

                  trigger={["hover"]}
                  mouseLeaveDelay={0}>
                    
                      <span
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}>
                      
                        {title && title.length > 100 ?
                      `${title.slice(0, 20)}...` :
                      title}
                      </span>
                    </Tooltip>
                  </p>
                  {"  "}&nbsp;{" "}
                  {bidData?.received ?
                <>
                      {favLoading ?
                  <div
                  style={{
                    float: "right",
                    color: "#118936"
                  }}>
                    
                          <LoadingOutlined />
                        </div> :

                  <span style={{ color: "#ffba08" }}>
                          {rating == undefined ? "" : rating}
                        </span>}
                  {" "}
                      <span style={{ color: "#1e1e1e" }}>
                        {reviews == undefined ? "" : reviews}
                      </span>
                      <span
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMessageClick(bidData);
                    dispatch(resetChatHistory());
                  }}>
                    
                        <img
                    style={{ marginLeft: "5px" }}
                    src={messageIcon}
                    alt="messageIcon" />
                    
                      </span>
                    </> :
                null}
                </p>
                {bidData?.received ? null :
              <div className="candidateName">
                    {candidateName == undefined || type == "recieved" ?
                " " :
                capitalizeFirstLetter(candidateName)}{" "}
                    &nbsp;
                    <span style={{ color: "#ffba08" }}>
                      {rating == undefined ? "" : rating}
                    </span>{" "}
                    {reviews == undefined ? "" : reviews}{" "}
                    <span
                onClick={(e) => {
                  e.stopPropagation();
                  handleMessageClick(bidData);
                  dispatch(resetChatHistory());
                }}>
                  
                      <img
                  style={{ marginLeft: "5px" }}
                  src={messageIcon}
                  alt="messageIcon" />
                  
                    </span>
                  </div>}
              
                <div className="contact-container">
                  {bidData?.user?.EmailAddress &&
                <span className="email-container">
                      {" "}
                      <AiOutlineMail />
                      &nbsp;{bidData?.user?.EmailAddress}
                    </span>}
                
                  {phoneNumber &&
                <span className="phone-container">
                      {" "}
                      &nbsp;
                      <BsTelephone className="ct-contact-icon" /> &nbsp;
                      {phoneNumber && formatPhoneNumber(phoneNumber)}
                    </span>}
                
               {bidData?.gigs?.VMS || bidData?.VMS ?
                <div style={{ position: 'relative', bottom: '10px' }}>
    <div className="vms-tag">
      <span>{bidData?.gigs?.VMS || bidData?.VMS}</span>
    </div>
  </div> :
                null}

                  <TimeSheetButton
                handleConfigTimeSheetClick={(e) => {
                  e?.stopPropagation();
                  handleConfigTimeSheetClick(bidData);
                }}
                handleViewTimeSheet={(e) => {
                  e?.stopPropagation();
                  handleViewTimeSheet(bidData);
                }}
                handleTimeOff={(e) => {
                  handleTimeOff(bidData);
                }}
                isTimeOff={bidData?.isTimeOff}
                isAlreadyConfTimeSheetByAnotherEmployer={
                bidData?.isAlreadyConfTimeSheetByAnotherEmployer}

                currentEmployerTimesheetIsAlreadyConfigured={
                bidData?.currentEmployerTimesheetIsAlreadyConfigured}

                disableConfigButton={
                negativeBidStatus.includes(
                bidData?.statuses?.BidStatusName) ||
                false}

                isActiveTimeSheets={bidData?.isActiveTimeSheets}
                isNeitherCurrentNorOtherEmployerConfigured={
                bidData?.isNeitherCurrentNorOtherEmployerConfigured} />

                
                </div>
              </div>
            </div>
          </>);

    }
  },
  {
    title: "Job Details",
    dataIndex: "jobdetails",
    render: ({ jobtitle, workPlacePolicyName, JobId, FacilityName }) => {
      return (
        <>
            <div
          className="jobDetailsContainer"
          onClick={(e) => {
            e.stopPropagation();

            history.push({
              pathname: `/jobdetail/${JobId}`,
              state: {
                id: JobId
              }
            });
          }}>
            
              <p className="jobTitle">
                {jobtitle == undefined ? "-" : jobtitle}
              </p>
              <p className="" style={{ fontSize: "13px" }}>
                {isNonHC(profile?.Professions?.ProfessionCode) ?
              workPlacePolicyName :
              FacilityName}
              </p>
            </div>
          </>);

    }
  },
  {
    title: "Bid Type",
    dataIndex: "type",
    render: ({ bidType }) => {
      return (
        <>
            <div className="bidsDateContainer">
              <p className="candidateName">
                {<PlacedAndReceived bidType={bidType} />}
                {/* {bidsDate == undefined ? "-" : bidsDate} */}
              </p>
            </div>
          </>);

    }
  },
  {
    title: tableBidType,
    // `${bidTypeName == "Received_Bid" ? "Bids Received Date" : "Bids Placed Date"}`
    dataIndex: "bids",
    render: ({ bidsDate }) => {
      return (
        <>
            <div className="bidsDateContainer">
              <p className="candidateName">
                {bidsDate == undefined ? "-" : bidsDate}
              </p>
            </div>
          </>);

    }
  },
  {
    title: "Assignee",
    // bidTypeName == "Received_Bid" ? "Bids Received To" : "Bids Placed By",
    dataIndex: "bidsPlacedBy",
    render: ({ name }) => {
      return (
        <>
            <div className="bidsDateContainer">
              <p className="candidateName">{name}</p>
            </div>
          </>);

    }
  },
  {
    title: "Status",
    dataIndex: "status",

    render: ({ status, bidData, SkillListings, history }) => {
      return (
        <>
            <div className="statusRow">
              <CustomDropdown
            status={status}
            bidData={bidData}
            setStatusName={setBidStatusName}
            applyFilter={applyBidsFilters}
            SkillListings={SkillListings} />
            
              <CustomModal status={status} history={history} />
            </div>
          </>);

    }
  }];


  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  useEffect(() => {
    resultHandler();
  }, [count_Success]);

  useEffect(() => {
    if (
    update_bid_success ||
    retract_bid_success ||
    create_interview_success ||
    update_proposal_success ||
    update_interview_success ||
    make_offer_success ||
    edit_offer_success)
    {
      setTableData([]);
      dispatch(
      getCandidateCount({
        bid_type_name: bidTypeName,
        startdate: startDate,
        enddate: endDate,
        ABSId: absId,
        id: HrmId,
        bidType: candidateType,
        searchTerm: searchText,
        timeSheetType,
        vmsTypes: selectedVms.join(','),
        facilityTypes: selectedFacilities.join(',')
      }));

      dispatch(
      getCandidates({
        bid_status_name: bidStatusName,
        bid_type_name: bidTypeName,
        startdate: startDate,
        enddate: endDate,
        page: page > 1 ? 1 : page,
        perPage: perPage,
        ABSId: absId,
        id: HrmId,
        bidType: candidateType,
        searchTerm: searchText,
        timeSheetType,
        vmsTypes: selectedVms.join(','),
        facilityTypes: selectedFacilities.join(',')
      }));

      // resultHandler();
    }
    // resultHandler();
  }, [
  update_bid_success,
  retract_bid_success,
  create_interview_success,
  update_interview_success,
  update_proposal_success,
  make_offer_success,
  edit_offer_success]);


  const getBidStatusValueAfterScheduleCall = (item) => {
    if (item?.offers?.Status == "Hired") return item?.statuses?.BidStatusName;else
    if (item?.offers?.Status == "Pending") return "Offer";else
    if (item?.offers?.Status == "Accepted") return "Offer Accepted";
  };

  useEffect(() => {
    if (allBids != undefined) {
      setTableData(
      allBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item?.BidId :
                  item?.ProposalId || item?.received?.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item?.BidId :
                  item?.ProposalId || item?.received?.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} />,


            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            title: item.SkillListings?.Title ?
            item.SkillListings?.Title :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            candidateName: item.received ?
            " " :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            phoneNumber: item.received ?
            "" :
            item?.user?.Profiles?.MobilePhone &&
            item.user.Profiles.MobilePhone,
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "all"
          },
          jobdetails: {
            jobtitle: item.gigs?.Title ? item.gigs?.Title : item?.Title,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",

            JobId: item?.gigs?.JobOrderId ?
            item?.gigs?.JobOrderId :
            item.JobOrderId
          },
          bids: {
            bidsDate: item?.received ?
            moment(item?.received?.Created).fromNow() :
            moment(item?.Created).fromNow()
          },
          bidsPlacedBy: {
            name:
            item?.bidType === "Placed" ?
            item?.bidPlacedBy :
            item?.bidType === "Received" ?
            item?.bidReceivedTo :
            "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName == "Interview Cancelled" ?
            item?.statuses?.BidStatusName :
            ["Hired", "Pending", "Accepted"].includes(
            item?.offers?.Status) ?

            getBidStatusValueAfterScheduleCall(item) :
            item?.statuses?.BidStatusName
            }`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,

              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

      setTableDataOriginal(
      allBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} />,


            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            title: item.SkillListings?.Title ?
            item.SkillListings?.Title :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            candidateName: item.received ?
            " " :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            phoneNumber:
            item?.user?.Profiles?.MobilePhone &&
            item?.user?.Profiles?.MobilePhone,
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "all"
          },
          jobdetails: {
            jobtitle: item.gigs?.Title ? item.gigs?.Title : item?.Title,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",
            JobId: item?.gigs?.JobOrderId ?
            item?.gigs?.JobOrderId :
            item.JobOrderId
          },
          bids: {
            bidsDate: item?.received ?
            moment(item?.received?.Created).fromNow() :
            moment(item?.Created).fromNow()
          },
          bidsPlacedBy: {
            name:
            item?.bidType === "Placed" ?
            item?.bidPlacedBy :
            item?.bidType === "Received" ?
            item?.bidReceivedTo :
            "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName}`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,

              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

    }
    setDataArrayMobileOriginal(allBids);
    setDataArrayMobile(allBids);
  }, [allBids]);

  useEffect(() => {
    if (receivedBids != undefined) {
      setTableData(
      receivedBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} />,



            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            title: item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            candidateName:
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            "-",
            phoneNumber: item.received ?
            "" :
            item?.user?.Profiles?.MobilePhone &&
            item.user.Profiles.MobilePhone,
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "recieved"
          },
          jobdetails: {
            jobtitle: `${item?.Title}`,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",
            JobId: item?.JobOrderId
          },
          bids: {
            bidsDate: moment(item?.received?.Created).fromNow()
          },
          bidsPlacedBy: {
            name: item?.bidReceivedTo || "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName}`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,

              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

      setTableDataOriginal(
      receivedBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} />,


            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            title: item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",

            candidateName:
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            "-",

            phoneNumber:
            item?.user?.Profiles?.MobilePhone &&
            item?.user?.Profiles?.MobilePhone,
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "recieved"
          },
          jobdetails: {
            jobtitle: `${item?.Title}`,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",
            JobId: item?.JobOrderId
          },
          bids: {
            bidsDate: moment(item?.received?.Created).fromNow()
          },
          bidsPlacedBy: {
            name: item?.bidReceivedTo || "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName}`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,
              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

      setDataArrayMobileOriginal(receivedBids);
      setDataArrayMobile(receivedBids);
    }
  }, [receivedBids]);

  useEffect(() => {
    if (placedBids != undefined) {
      setTableData(
      placedBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

                setFavorite(!favorite);
              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

                setFavorite(!favorite);
              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

                setFavorite(!favorite);
              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

                setFavorite(!favorite);
              }
            }} />,


            title: `${item.SkillListings?.Title}`,
            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            candidateName: item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            phoneNumber:
            item?.user?.Profiles?.MobilePhone &&
            item.user.Profiles.MobilePhone,
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "placed"
          },
          jobdetails: {
            jobtitle: `${item.gigs?.Title}`,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",
            JobId: item?.gigs?.JobOrderId
          },
          bids: { bidsDate: moment(item?.Created).fromNow() },
          bidsPlacedBy: {
            name: item?.bidPlacedBy || "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName}`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,
              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

      setTableDataOriginal(
      placedBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} />,


            title: `${item.SkillListings?.Title}`,
            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            candidateName: item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "placed"
          },
          jobdetails: {
            jobtitle: `${item.gigs?.Title}`,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",
            JobId: item?.gigs?.JobOrderId
          },
          bids: { bidsDate: moment(item?.Created).fromNow() },
          bidsPlacedBy: {
            name: item?.bidPlacedBy || "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName}`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,
              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

      setDataArrayMobileOriginal(placedBids);
      setDataArrayMobile(placedBids);
    }
  }, [placedBids]);
  useEffect(() => {
    if (favouriteBids != undefined) {
      setTableData(
      favouriteBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} />,


            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            title: item.SkillListings?.Title ?
            item.SkillListings?.Title :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            candidateName: item.received ?
            " " :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "all"
          },
          jobdetails: {
            jobtitle: item.gigs?.Title ? item.gigs?.Title : item?.Title,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",
            JobId: item?.gigs?.JobOrderId ?
            item?.gigs?.JobOrderId :
            item.JobOrderId
          },
          bids: {
            bidsDate: item?.received ?
            moment(item?.received?.Created).fromNow() :
            moment(item?.Created).fromNow()
          },
          bidsPlacedBy: {
            name: item?.bidPlacedBy || item?.bidReceivedTo || "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName}`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,
              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

      setTableDataOriginal(
      favouriteBids?.map((item, index) => {
        return {
          key: `${index + 1}`,
          cdetails: {
            rate: item.IsFavorite ?
            <Rate
            count="1"
            defaultValue={1}
            onChange={(value) => {
              if (value == 0) {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} /> :


            <Rate
            count="1"
            onChange={(value) => {
              if (value == 1) {
                dispatch(
                addMessageToFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              } else {
                dispatch(
                removeMessageFromFavourite({
                  SourceId: item.SkillListings ?
                  item.BidId :
                  item.received.ProposalId,
                  SourceName: item.SkillListings ? "Bid" : "Proposal"
                }));

              }
            }} />,


            image: item.user?.Profiles?.PictureUrl ?
            item.user?.Profiles?.PictureUrl :
            "",
            title: item.SkillListings?.Title ?
            item.SkillListings?.Title :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            candidateName: item.received ?
            " " :
            item?.user?.Profiles?.FirstName ?
            item?.user?.Profiles?.FirstName +
            " " +
            item?.user?.Profiles?.LastName :
            item?.user && item?.user?.UserName != null ?
            item?.user?.UserName :
            "-",
            rating: `${item?.user?.Profiles?.Rating ?? DefaultRating}`,
            reviews: `(${item?.user?.Profiles?.Review ?? "0"})`,
            bidData: item,
            type: "all"
          },
          jobdetails: {
            jobtitle: item.gigs?.Title ? item.gigs?.Title : item?.Title,
            workPlacePolicyName: item?.gigs ?
            item?.gigs?.WorkplacePolicy :
            item?.WorkplacePolicy ?? "-",
            FacilityName: item?.gigs ?
            item?.gigs?.FacilityName :
            item?.FacilityName ?? "-",
            JobId: item?.gigs?.JobOrderId ?
            item?.gigs?.JobOrderId :
            item.JobOrderId
          },
          bids: {
            bidsDate: item?.received ?
            moment(item?.received?.Created).fromNow() :
            moment(item?.Created).fromNow()
          },
          bidsPlacedBy: {
            name: item?.bidPlacedBy || item?.bidReceivedTo || "N/A"
          },
          status: {
            status: `${item?.statuses?.BidStatusName}`,
            bidData: item,
            SkillListings: item.SkillListings,
            history: {
              createdDate: item?.bid_stages?.Created,
              AcceptedDate: item?.bid_stages?.TalentReactOn,
              profileSubmited: item?.bid_stages?.SubmittedOn,
              interview: item?.bid_stages?.InterviewedOn,
              interviewRejectOn: item?.bid_stages?.InterviewedRejectOn,
              offerAccepted: item?.bid_stages?.OfferReactOn,
              BillingExpiredOn: item?.bid_stages?.BillingExpiredOn,
              BillingExtendOffOn: item?.bid_stages?.BillingExtendOffOn,
              BillingExtendedOn: item?.bid_stages?.BillingExtendedOn,
              BillingOffOn: item?.bid_stages?.BillingOffOn,
              BillingOn: item?.bid_stages?.BillingOn,
              CredentialingOn: item?.bid_stages?.CredentialingOn,
              DropOutOn: item?.bid_stages?.DropOutOn,
              HiredOn: item?.bid_stages?.HiredOn,
              Modified: item?.bid_stages?.Modified,
              OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
            }
          },
          type: { bidType: item?.bidType ? item?.bidType : "-" }
        };
      }));

      setDataArrayMobileOriginal(favouriteBids);
      setDataArrayMobile(favouriteBids);
    }
  }, [favouriteBids]);
  const applyBidsFilters = (
  type,
  name,
  HrmId,
  start,
  end,
  bidType = candidateType,
  searchTerm = searchText,
  _absId = absId,
  _timeSheetType = timeSheetType,
  newSelectedVms = selectedVms,
  newSelectedFacilities = selectedFacilities) =>
  {
    setDataArrayMobileOriginal([]);
    setDataArrayMobile([]);
    setTableData([]);
    setTableDataOriginal([]);
    addQuery("stage", name); //bidStatusName
    addQuery("type", type); //bidTypeName
    addQuery("HRM", HrmId);
    addQuery("absId", _absId);
    addQuery("StartDate", startDate);
    addQuery("EndDate", endDate);
    addQuery("bidType", bidType);
    addQuery("searchTerm", searchTerm);
    addQuery("page", 1);
    addQuery("timeSheetType", _timeSheetType);
    const vmsStr = newSelectedVms.join(',');
    const facStr = newSelectedFacilities.join(',');
    addQuery("vmsTypes", vmsStr);
    addQuery("facilityTypes", facStr);
    setPage(1);
    // if (HrmId != profile?.AccountId) {
    dispatch(
    getCandidateCount({
      bid_type_name: type ? type : bidTypeName,
      startdate: start ? start : startDate,
      enddate: end ? end : endDate,
      ABSId: _absId,
      id: HrmId,
      bidType,
      searchTerm,
      timeSheetType: _timeSheetType,
      vmsTypes: newSelectedVms.join(','),
      facilityTypes: newSelectedFacilities.join(',')
    }));

    dispatch(
    getCandidates({
      bid_type_name: type ? type : bidTypeName,
      bid_status_name: name ? name : bidStatusName,
      startdate: start ? start : startDate,
      enddate: end ? end : endDate,
      page: page > 1 ? 1 : page,
      perPage: perPage,
      ABSId: _absId,
      id: HrmId,
      bidType,
      searchTerm,
      timeSheetType: _timeSheetType,
      vmsTypes: newSelectedVms.join(','),
      facilityTypes: newSelectedFacilities.join(',')
    }));

  };
  const onChangePage = (page) => {
    setPage(page);
  };
  const clearBidsFilters = () => {
    removeQuery("page", page);
    setPage(1);
    removeQuery("stage", bidStatusName);
    removeQuery("type", bidTypeName);
    removeQuery("absId", absId);
    removeQuery("HRM", HrmId);
    removeQuery("hrmName");
    removeQuery("absName");
    removeQuery("StartDate", startDate);
    removeQuery("EndDate", endDate);
    removeQuery("bidType", candidateType);
    removeQuery("searchTerm");
    removeQuery("timeSheetType");
    removeQuery("vmsTypes");
    removeQuery("facilityTypes");
    // resultHandler();
    setAbsId(getAbsDetails().id);
    setHrmId(null);
    setAbsName(getAbsDetails().name);
    setHrmName(null);
    setSelectedVms([]);
    setSelectedFacilities([]);
    setBidTypeFilterValue(1);
    setBidStatusFilterValue(18);
    setBidTypeName("All_Bids");
    setBidStatusName("All");
    setStartDate("");
    setEndDate("");
    setSearchText("");
    setCandidateType("all");
    setTimeSheetType("all");
    setPage(1);
    dispatch(
    getCandidateCount({
      bid_type_name: "All_Bids",
      startdate: "",
      enddate: "",
      vmsTypes: '',
      facilityTypes: ''
    }));

    dispatch(
    getCandidates({
      bid_type_name: "All_Bids",
      bid_status_name: "All",
      startdate: "",
      enddate: "",
      page: 1,
      perPage: 10,
      vmsTypes: '',
      facilityTypes: ''
    }));

  };
  const onChangeHRMIdFilter = (e) => {
    setHrmId(e.target.value);
  };
  const onChangeBidTypeFilter = (e) => {
    setBidTypeFilterValue(e.target.value);
  };
  const onChangeTimeSheetFilter = (e) => {
    setTimeSheetType(e.target.value);
  };
  const onChangeBidStatusFilter = (e) => {
    setBidStatusFilterValue(e.target.value);
  };
  const applyFilter = () => {
    var bidType;
    var bidStatus;
    setPage(1);
    if (bidTypeFilterValue == 1) {
      setBidTypeName("All_Bids");
      bidType = "All_Bids";
    } else if (bidTypeFilterValue == 2) {
      setBidTypeName("Placed_Bid");
      bidType = "Placed_Bid";
    } else if (bidTypeFilterValue == 3) {
      setBidTypeName("Received_Bid");
      bidType = "Received_Bid";
    } else if (bidTypeFilterValue == 4) {
      setBidTypeName("Favorites");
      bidType = "Favorites";
    }
    if (bidStatusFilterValue == 1) {
      setBidStatusName("New_Bid");
      bidStatus = "New_Bid";
    } else if (bidStatusFilterValue == 18) {
      setBidStatusName("All");
      bidStatus = "All";
    } else if (bidStatusFilterValue == 2) {
      setBidStatusName("Accepted_Bids");
      bidStatus = "Accepted_Bids";
    } else if (bidStatusFilterValue == 3) {
      setBidStatusName("Declined_Bids");
      bidStatus = "Declined_Bids";
    } else if (bidStatusFilterValue == 4) {
      setBidStatusName("Profile_Submitted");
      bidStatus = "Profile_Submitted";
    } else if (bidStatusFilterValue == 5) {
      setBidStatusName("Interview_Proposed");
      bidStatus = "Interview_Proposed";
    } else if (bidStatusFilterValue == 6) {
      setBidStatusName("Interview_Accepted");
      bidStatus = "Interview_Accepted";
    } else if (bidStatusFilterValue == 7) {
      setBidStatusName("Interview_Declined");
      bidStatus = "Interview_Declined";
    } else if (bidStatusFilterValue == 8) {
      setBidStatusName("Interview_Cancelled");
      bidStatus = "Interview_Cancelled";
    } else if (bidStatusFilterValue == 9) {
      setBidStatusName("Offer_Sent");
      bidStatus = "Offer_Sent";
    } else if (bidStatusFilterValue == 10) {
      setBidStatusName("Offer_Accepted");
      bidStatus = "Offer_Accepted";
    } else if (bidStatusFilterValue == 11) {
      setBidStatusName("Offer_Declined");
      bidStatus = "Offer_Declined";
    } else if (bidStatusFilterValue == 12) {
      setBidStatusName("Hired");
      bidStatus = "Hired";
    } else if (bidStatusFilterValue == 13) {
      setBidStatusName("On_Billing");
      bidStatus = "On_Billing";
    } else if (bidStatusFilterValue == 14) {
      setBidStatusName("Billing_Extended");
      bidStatus = "Billing_Extended";
    } else if (bidStatusFilterValue == 15) {
      setBidStatusName("Off_Billing");
      bidStatus = "Off_Billing";
    } else if (bidStatusFilterValue == 17) {
      setBidStatusName("Cancelled");
      bidStatus = "Cancelled";
    } else if (bidStatusFilterValue == 16) {
      setBidStatusName("Terminated");
      bidStatus = "Terminated";
    }
    setVisibleStatusDrawer(false);
    setDataArrayMobileOriginal([]);
    setDataArrayMobile([]);
    setTableData([]);
    setTableDataOriginal([]);
    addQuery("stage", bidStatusName);
    addQuery("type", bidTypeName);
    addQuery("HRM", HrmId);
    addQuery("absId", absId);
    addQuery("StartDate", startDate);
    addQuery("EndDate", endDate);
    addQuery("bidType", candidateType);
    addQuery("timeSheetType", timeSheetType);
    dispatch(
    getCandidateCount({
      bid_type_name: bidType,
      startdate: startDate,
      enddate: endDate,
      bidType: candidateType,
      ABSId: absId,
      id: HrmId,
      searchTerm: searchText,
      timeSheetType,
      vmsTypes: selectedVms.join(','),
      facilityTypes: selectedFacilities.join(',')
    }));

    dispatch(
    getCandidates({
      bid_type_name: bidType,
      bid_status_name: bidStatus,
      startdate: startDate,
      enddate: endDate,
      page: page > 1 ? 1 : page,
      perPage: perPage,
      ABSId: absId,
      id: HrmId,
      bidType: candidateType,
      searchTerm: searchText,
      timeSheetType,
      vmsTypes: selectedVms.join(','),
      facilityTypes: selectedFacilities.join(',')
    }));

  };
  const bidsTypeMenu =
  <Menu
  style={{ border: "solid 1px #dedede" }}
  onClick={async (menuItem) => {
    setBidTypeName(menuItem.key);
    applyBidsFilters(menuItem.key, bidStatusName, HrmId);
  }}>
    
      <Menu.Item key="All_Bids">All Bid Type</Menu.Item>
      <Menu.Item key="Placed_Bid">Placed bid</Menu.Item>
      <Menu.Item key="Received_Bid">Received bid</Menu.Item>
      <Menu.Item key="Favorites">Favorites</Menu.Item>
    </Menu>;

  const candidateTypeMenu =
  <Menu
  style={{ border: "solid 1px #dedede" }}
  onClick={(menuItem) => {
    setCandidateType(menuItem.key);
    applyBidsFilters(
    bidTypeName,
    bidStatusName,
    HrmId,
    startDate,
    endDate,
    menuItem.key);

  }}>
    
      <Menu.Item key="all">All candidates</Menu.Item>
      <Menu.Item key="private">Private candidates</Menu.Item>
    </Menu>;

  const handleTimeSheetChange = (value) => {
    setTimeSheetType(value);
    applyBidsFilters(
    bidTypeName,
    bidStatusName,
    HrmId,
    startDate,
    endDate,
    undefined,
    undefined,
    undefined,
    value);

  };
  const timeSheetMenu =
  <Menu
  style={{ border: "solid 1px #dedede" }}
  onClick={(menuItem) => handleTimeSheetChange(menuItem.key)}>
    
      {TIME_SHEET_MENU_OPTIONS.map((option) =>
    <Menu.Item key={option.value}>{option.title}</Menu.Item>)}
    
    </Menu>;

  const bidsStatusMenu =
  <Menu
  style={{ border: "solid 1px #dedede" }}
  onClick={(menuItem) => {
    setBidStatusName(menuItem.key);
    applyBidsFilters(bidTypeName, menuItem.key, HrmId);
  }}>
    
      <Menu.Item key="All">All</Menu.Item>
      <Menu.Item key="New_Bid">New bids</Menu.Item>
      <Menu.Item key="Accepted_Bids">Accepted bids</Menu.Item>
      <Menu.Item key="Declined_Bids">Declined bids</Menu.Item>
      <Menu.Item key="Retracted">Retracted bids</Menu.Item>
      <Menu.Item key="Profile_Submitted">Profile submitted</Menu.Item>
      <Menu.Item key="Interview_Proposed">Interview proposed</Menu.Item>
      <Menu.Item key="Interview_Accepted">Interview accepted</Menu.Item>
      {/* <Menu.Item key="Interview_Declined">Interview declined</Menu.Item> */}
      <Menu.Item key="Interview_Cancelled">Interview canceled</Menu.Item>
      <Menu.Item key="Offer_Sent">Offer sent</Menu.Item>
      <Menu.Item key="Offer_Accepted">Offer accepted</Menu.Item>
      <Menu.Item key="Offer_Declined">Offer declined</Menu.Item>
      <Menu.Item key="Hired">Hired</Menu.Item>
      <Menu.Item key="On_Billing">On billing</Menu.Item>
      <Menu.Item key="Billing_Extended">Billing extended</Menu.Item>
      <Menu.Item key="Off_Billing">Off billing</Menu.Item>
      <Menu.Item key="Terminated">Terminated</Menu.Item>
      <Menu.Item key="Cancelled">Canceled</Menu.Item>
    </Menu>;



  const HrmMenu =
  <Menu
  style={{ border: "solid 1px #dedede" }}
  onClick={(menuItem) => {
    setHrmId(menuItem.key);
  }}>
    
      {HRMs.length != 0 ?
    HRMs.map((item) => {
      return (
        <Menu.Item key={item?.AccountId}>
              {/* {item?.UserName} */}
            </Menu.Item>);

    }) :
    null}
    </Menu>;

  const onCloseStatusDrawer = () => {
    setVisibleStatusDrawer(false);
  };

  function debounce(func, timeout = 1500) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  const handleSearch = ({
    searchTerm,
    bidTypeName,
    startDate,
    endDate,
    candidateType,
    HrmId,
    profile,
    bidStatusName,
    page,
    perPage
  }) => {
    if (searchTerm) addQuery("searchTerm", searchTerm);else
    removeQuery("searchTerm");
    addQuery("page", 1);
    setPage(1);

    dispatch(
    getCandidateCount({
      bid_type_name: bidTypeName,
      startdate: startDate,
      enddate: endDate,
      ABSId: absId,
      id: HrmId,
      bidType: candidateType,
      searchTerm,
      vmsTypes: selectedVms.join(','),
      facilityTypes: selectedFacilities.join(',')
    }));

    dispatch(
    getCandidates({
      bid_type_name: bidTypeName,
      bid_status_name: bidStatusName,
      startdate: startDate,
      enddate: endDate,
      page: 1,
      perPage: perPage,
      ABSId: absId,
      id: HrmId,
      bidType: candidateType,
      searchTerm,
      vmsTypes: selectedVms.join(','),
      facilityTypes: selectedFacilities.join(',')
    }));

    // } else {
    // dispatch(
    // getCandidateCount({
    // bid_type_name: bidTypeName,
    // startdate: startDate,
    // enddate: endDate,
    // bidType: candidateType,
    // searchTerm,
    // })
    // );
    // dispatch(
    // getCandidates({
    // bid_type_name: bidTypeName,
    // bid_status_name: bidStatusName,
    // startdate: startDate,
    // enddate: endDate,
    // page: 1,
    // perPage: perPage,
    // bidType: candidateType,
    // searchTerm,
    // })
    // );
    // }
  };

  const onChangeSearch = (e) => {
    let _searchText = e.target.value;
    const currValue = _searchText.toLowerCase();
    setSearchText(currValue);
  };

  const onEnterSearch = (e) => {
    if (e.key == "Enter") {
      let _searchText = e.target.value;
      const currValue = _searchText.toLowerCase();
      handleSearch({
        searchTerm: currValue,
        bidTypeName,
        startDate,
        endDate,
        candidateType,
        HrmId,
        profile,
        bidStatusName,
        page,
        perPage
      });
    }
  };
  const handleSelectABS = ({
    ABSProfileId = null,
    ABSLastName = null,
    ABSFirstName = null,
    isWeb = true
  }) => {
    setAbsName(getFullName(ABSFirstName, ABSLastName));
    setAbsId(ABSProfileId);
    addQuery("absName", getFullName(ABSFirstName, ABSLastName));
    addQuery("hrmName", null);
    getABSChild(ABSProfileId);
    setHrmId(null);
    setHrmName(null);
    if (isWeb)
    applyBidsFilters(
    bidTypeName,
    bidStatusName,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    ABSProfileId);

  };
  const getABSChild = (id) => {
    dispatch(getHRMDetailInit({ absAccountId: id }));
  };
  const handleSelectHRM = ({
    FirstName = null,
    LastName = null,
    AccountId = null,
    isWeb = true
  }) => {
    const fullName = getFullName(FirstName, LastName);
    setHrmName(fullName);
    addQuery("hrmName", fullName);
    setHrmId(AccountId);
    if (isWeb)
    applyBidsFilters(
    bidTypeName,
    bidStatusName,
    AccountId,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined
    // absName,
    // getFullName(FirstName, LastName)
    );
  };
  const handleVmsOpenChange = (open) => {
    setVmsDropdownOpen(open);
    if (open) {
      setTempSelectedVms([...selectedVms]); // Sync temp with selected on open
    }
  };

  const handleFacilityOpenChange = (open) => {
    setFacilityDropdownOpen(open);
    if (open) {
      setTempSelectedFacilities([...selectedFacilities]); // Sync temp with selected on open
      setFacilitySearchText(''); // Reset search
    }
  };
  return loading || hireLoading ?
  <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: ":center"
  }}>
    
      <Loader />
    </div> :

  <div style={{ marginBottom: "40px" }}>
      {favourite_status === "added" ?
    <TopAlert
    display={"flex"}
    title={"Skill listing added to favorites"}
    type={"success"} /> :

    null}
      {favourite_status === "removed" ?
    <TopAlert
    display={"flex"}
    title={"Skill listing removed from favorites"}
    type={"success"} /> :

    null}
      {Dimensions.width < 769 ?
    <div>
         <Drawer
      open={visibleStatusDrawer}
      placement="top"
      height={Dimensions.height}
      closable={false}
      title={
      <div>
      <Row>
        <Col
          xs={4}
          className={"clearAll"}
          style={{ justifyContent: "flex-start" }}
          onClick={() => {
            setVisibleStatusDrawer(false);
            clearBidsFilters();
          }}>
            
          Clear All
        </Col>
        <Col xs={18} className={"filter-text"}>
          Filter
        </Col>
        <Col
          xs={2}
          style={{ textAlign: "center", cursor: "pointer" }}
          onClick={onCloseStatusDrawer}>
            
          <CloseOutlined style={{ color: "#9e9e9e" }} />
        </Col>
      </Row>
    </div>}>

        
  <>
    <div style={{ height: "100%", overflowY: "scroll" }}>
      {profile?.MasterAccountId == null &&
            userProfile?.PvtEmpName !== "SG-PTM" &&
            ABS?.length > 0 ?
            <>
          <ABSFilter
              selectedId={absId}
              label={"ABS"}
              isMobileView={true}
              disabled={isAbs}
              name={"All (ABS)"}
              dispatchFunction={absDetailInit}
              onSelect={handleSelectABS}
              value={absName}
              getFullName={(abs) =>
              getFullName(abs.ABSFirstName, abs.ABSLastName)} />

              
          <ABSFilter
              selectedId={HrmId}
              isMobileView={true}
              disabled={isNull(absId)}
              name={"All"}
              dispatchFunction={getHRMDetailInit}
              isChild={true}
              onSelect={handleSelectHRM}
              value={HrmName}
              getFullName={(abs) =>
              getFullName(abs.FirstName, abs.LastName)}

              otherPayload={{ absAccountId: absId }}
              selectedAbs={{ id: absId, name: absName }} />
              
        </> :

            profile?.MasterAccountId == null && userProfile?.PvtEmpName == "SG-PTM" ?
            <ABSFilter
            selectedId={HrmId}
            isMobileView={true}
            name={"All"}
            dispatchFunction={getHRMDetailInit}
            isChild={true}
            onSelect={handleSelectHRM}
            value={HrmName}
            getFullName={(abs) =>
            getFullName(abs.FirstName, abs.LastName)}

            otherPayload={{ absAccountId: absId }}
            selectedAbs={{ id: absId, name: absName }} /> :
            ''}
      <div className="jobStatusDropDownText">All Candidates</div>
      <Radio.Group
            style={{ width: "100%" }}
            onChange={(e) => {
              setCandidateType(e.target.value);
            }}
            value={candidateType}>
              
        <Space direction="vertical" style={{ display: "flex" }}>
          <Radio className="radio-btnss" value={"all"}>
            All Candidates
          </Radio>
          <Radio className="radio-btnss" value={"private"}>
            Private Candidates
          </Radio>
        </Space>
      </Radio.Group>
   
      <div className="jobStatusDropDownText">Bid type</div>
      <Radio.Group
            style={{ width: "100%" }}
            onChange={onChangeBidTypeFilter}
            value={bidTypeFilterValue}>
              
        <Space direction="vertical" style={{ display: "flex" }}>
          <Radio className="radio-btnss" value={1}>
            All Bid Type
          </Radio>
          <Radio className="radio-btnss" value={2}>
            Placed bid
          </Radio>
          <Radio className="radio-btnss" value={3}>
            Received bid
          </Radio>
          <Radio className="radio-btnss" value={4}>
            Favorites
          </Radio>
        </Space>
      </Radio.Group>
   
      <div className="jobStatusDropDownText">
        Filter by bid status
      </div>
      <Radio.Group
            style={{ width: "100%" }}
            onChange={onChangeBidStatusFilter}
            value={bidStatusFilterValue}>
              
        <Space direction="vertical" style={{ display: "flex" }}>
          <Radio className="radio-btnss" value={18}>
            All
          </Radio>
          <Radio className="radio-btnss" value={1}>
            New bids
          </Radio>
          <Radio className="radio-btnss" value={2}>
            Accepted bids
          </Radio>
          <Radio className="radio-btnss" value={3}>
            Declined bids
          </Radio>
          <Radio className="radio-btnss" value={4}>
            Profile submitted
          </Radio>
          <Radio className="radio-btnss" value={5}>
            Interview proposed
          </Radio>
          <Radio className="radio-btnss" value={6}>
            Interview accepted
          </Radio>
          <Radio className="radio-btnss" value={8}>
            Interview canceled
          </Radio>
          <Radio className="radio-btnss" value={9}>
            Offer sent
          </Radio>
          <Radio className="radio-btnss" value={10}>
            Offer accepted
          </Radio>
          <Radio className="radio-btnss" value={11}>
            Offer declined
          </Radio>
          <Radio className="radio-btnss" value={12}>
            Hired
          </Radio>
          <Radio className="radio-btnss" value={13}>
            On Billing
          </Radio>
          <Radio className="radio-btnss" value={14}>
            Billing extended
          </Radio>
          <Radio className="radio-btnss" value={15}>
            Off Billing
          </Radio>
          <Radio className="radio-btnss" value={16}>
            Terminated
          </Radio>
          <Radio className="radio-btnss" value={17}>
            Canceled
          </Radio>
        </Space>
      </Radio.Group>
    
   
      <div className="jobStatusDropDownText">
        Filter by Start and End Date
      </div>
      <div className="DatePickerM">
        <RangePicker
              size="small"
              onFocus={() => {
                setDateFocussed(true);
              }}
              onBlur={() => {
                setDateFocussed(false);
              }}
              onChange={(e) => {
                if (e?.length > 0) {
                  setStartDate(e[0]?.toDate().toISOString());
                  setEndDate(e[1].toDate().toISOString());
                  applyBidsFilters(
                  bidTypeName,
                  bidStatusName,
                  HrmId,
                  e[0]?.toDate().toISOString(),
                  e[1].toDate().toISOString());

                } else if (e == null) {
                  setStartDate("");
                  setEndDate("");
                } else {
                  setStartDate();
                  setEndDate();
                }
              }}
              className={
              dateFocussed ? "hoveredDateRange" : "dateRange"}

              defaultValue={
              startDate != "" &&
              endDate != "" && [moment(startDate), moment(endDate)]}

              format={"DD/MM/YYYY"} />
              
      </div>
   
      {!isRestrictedPlan && <>
      <div className="jobStatusDropDownText">
        Timesheet Management
      </div>
      <Radio.Group
            style={{ width: "100%" }}
            onChange={onChangeTimeSheetFilter}
            value={timeSheetType}>

        <Space direction="vertical" style={{ display: "flex" }}>
          {TIME_SHEET_MENU_OPTIONS.map((option) =>
                <Radio className="radio-btnss" value={option.value}>
              {option.title}
            </Radio>)}

        </Space>
      </Radio.Group>
      <Divider style={{ marginTop: "10px" }} />
      </>}
      <button
            onClick={applyFilter}
            className={"applyFilterDrawer-btn"}>
              
        Apply filter
      </button>
    </div>
  </>
      </Drawer>
          <div className="Manage-candidate-mobile-header">
            {inputWidth ? null :
        <>
                <div className="manageCandidateTitle-mobile">
                  Manage Candidate Stages
                </div>
                <div
          className="Manage-candidate-header-filter"
          onClick={() => setVisibleStatusDrawer(true)}>
            
                  <img
            className="Manage-candidate-header-filter-image"
            src={filterIcon}
            alt="filterIcon" />
            
                  <div className="Manage-candidate-header-filter-count">
                    {bidStatusRadioValue == "null" ? 2 : 3}
                  </div>
                </div>
              </>}
        
            <div
        className="Manage-candidate-header-filter-search"
        onClick={() => setInputWidth(true)}
        style={{
          width: inputWidth ? "81.3%" : "9%",
          transition: inputWidth && "width 1s"
        }}>
          
              <Input
          type={"input"}
          className="Manage-candidate-header-input"
          prefix={
          <SearchOutlined
          style={{ color: "#7e7e7e", fontSize: "4.5vw" }} />}


          placeholder="Find skill listing title or job title"
          allowClear
          onChange={onChangeSearch}
          onKeyUp={onEnterSearch} />
          
              {inputWidth &&
          <div className="cross-icon-div">
                  <CloseOutlined
            onClick={(event) => {
              setInputWidth(false);
              event.stopPropagation();
            }}
            style={{ color: "#c4c4c4" }} />
            
                </div>}
          
            </div>
          </div>
          <div className="bidResults-Mobile">{result} Results</div>
          <div className="Manage-candidate-bidCardsContainer">
            {allBids?.length == 0 ?
        <div className="noJobsContainer">
                <img
          src={emptyjobs}
          alt="no-jobsimg"
          className="joblisting-noimg"
          style={{ width: "15rem", height: "9.3rem" }}>
          </img>
                <div className="Manage-candidate-joblisting-noimg">No data</div>
              </div> :
        null}
            {dataArrayMobile &&
        dataArrayMobile?.map((item, index) => {
          return (
            <div
            key={index}
            className="Manage-candidate-bidCard"
            // onClick= {event => {
            // if(item?.ConversationId){
            // history.push({
            // pathname: '/conversations',
            // state:{
            // openConvo: true,
            // conversationId: item?.ConversationId
            // }
            // })
            // }
            // }
            // }
            >
                    <div
              className="Manage-candidate-bidCard-candidate-details-row"
              onClick={(e) => {
                e.stopPropagation();
              }}
              style={{ position: "relative" }}>
                
                      {item.user?.Profiles.PictureUrl != null &&
                item.user?.Profiles.PictureUrl?.split("/")?.pop() !==
                "no-pic.png" ?
                <>
                          <Image
                  url={item.user?.Profiles?.PictureUrl}
                  mobile={true}
                  onClick={(e) => {
                    e.stopPropagation();
                    detailsPage(item);
                  }} />
                  
                          {isPrivate(item?.SkillListings?.CreatedBy) &&
                  <PrivateTagAvatar
                  isMobileView={Dimensions < 769}
                  size={"small"} />}

                  
                        </> :

                <div
                className="image-circle-filled-mobile"
                onClick={(e) => {
                  e.stopPropagation();
                  detailsPage(item);
                }}>
                  
                          {item.user?.Profiles.FirstName?.charAt(
                  0).
                  toUpperCase()}
                          {isPrivate(item?.SkillListings?.CreatedBy) &&
                  <PrivateTagAvatar
                  isMobileView={Dimensions < 769}
                  size={"small"} />}

                  
                        </div>}
                
                      <div
                className="Manage-candidate-bidCard-candidate-title-name"
                onClick={(e) => {
                  e.stopPropagation();
                  detailsPage(item);
                }}>
                  
                        <div className="Manage-candidate-bidCard-listing-title">
                          {item.SkillListings?.Title ?
                    <Tooltip
                    title={
                    capitalizeFirstLetter(
                    item.SkillListings.Title.slice(0, 100)) + (

                    item.SkillListings.Title.length > 100 ?
                    "..." :
                    "")}

                    trigger={["click"]}>
                      
                              <span onClick={(e) => e.stopPropagation()}>
                                {capitalizeFirstLetter(
                        item.SkillListings.Title)}
                        
                              </span>
                            </Tooltip> :
                    item?.user?.Profiles?.FirstName ?
                    capitalizeFirstLetter(
                    item?.user?.Profiles?.FirstName +
                    " " +
                    item?.user?.Profiles?.LastName) :

                    item?.user && item?.user?.UserName != null ?
                    capitalizeFirstLetter(item?.user?.UserName) :

                    "-"}
                    {" "}
                          {item?.received ?
                    <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMessageClick(item);
                      dispatch(resetChatHistory());
                    }}>
                      
                              <img src={messageIcon} alt="messageIcon" />
                            </span> :
                    null}
                        </div>
                        <div className="Manage-candidate-bidCard-candidate-name">
                          {item?.received ?
                    null :
                    item?.user?.Profiles?.FirstName ?
                    capitalizeFirstLetter(
                    item?.user?.Profiles?.FirstName +
                    " " +
                    item?.user?.Profiles?.LastName) :

                    "-"}{" "}
                          {item?.SkillListings ?
                    <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMessageClick(item);
                      dispatch(resetChatHistory());
                    }}>
                      
                              <img src={messageIcon} alt="messageIcon" />
                            </span> :
                    null}
                        </div>
                        <div className="Manage-candidate-bidCard-candidate-rating">
                          <img
                    src={starIcon}
                    alt="starIcon"
                    className="Manage-candidate-bidCard-candidate-rating-icon" />
                    
                          <span className="Manage-candidate-bidCard-candidate-rate">
                            {item?.user?.Profiles?.Rating ?
                      item?.user?.Profiles?.Rating :
                      DefaultRating}
                          </span>
                          &nbsp;{" "}
                          {item?.user?.Profiles?.Review ?
                    "(" + item?.user?.Profiles?.Review + ")" :
                    "(0)"}
                        </div>
                        {item?.user?.EmailAddress &&
                  <div
                  className="email-container"
                  style={{ marginTop: "0" }}>
                    
                            {" "}
                            <AiOutlineMail /> &nbsp;{item?.user?.EmailAddress}
                          </div>}
                  
                        {item?.user?.Profiles?.MobilePhone &&
                  <div className="phone-container">
                            <BsTelephone className="ct-contact-icon" /> &nbsp;
                            {formatPhoneNumber(
                    item?.user?.Profiles?.MobilePhone)}
                    
                          </div>}
                  
                        <TimeSheetButton
                  handleConfigTimeSheetClick={(e) => {
                    e?.stopPropagation();
                    handleConfigTimeSheetClick(item);
                  }}
                  handleViewTimeSheet={(e) => {
                    e?.stopPropagation();
                    handleViewTimeSheet(item);
                  }}
                  isTimeOff={item?.isTimeOff}
                  handleTimeOff={(e) => {
                    handleTimeOff(item);
                  }}
                  isAlreadyConfTimeSheetByAnotherEmployer={
                  item?.isAlreadyConfTimeSheetByAnotherEmployer}

                  currentEmployerTimesheetIsAlreadyConfigured={
                  item?.currentEmployerTimesheetIsAlreadyConfigured}

                  BidStatusName={item?.statuses?.BidStatusName}
                  isActiveTimeSheets={item?.isActiveTimeSheets}
                  isNeitherCurrentNorOtherEmployerConfigured={
                  item?.isNeitherCurrentNorOtherEmployerConfigured}

                  disableConfigButton={
                  negativeBidStatus.includes(
                  item?.statuses?.BidStatusName) ||
                  false} />

                  
                      </div>
                      <div
                className="Manage-candidate-bidCard-icon-container"
                onClick={(e) => {
                  e.stopPropagation();
                }}>
                  
                        {item.IsFavorite ?
                  <Rate
                  count="1"
                  defaultValue={1}
                  onChange={(value) => {
                    if (value == 0) {
                      dispatch(
                      removeMessageFromFavourite({
                        SourceId: item.SkillListings ?
                        item.BidId :
                        item.received.ProposalId,
                        SourceName: item.SkillListings ?
                        "Bid" :
                        "Proposal"
                      }));

                    } else {
                      dispatch(
                      addMessageToFavourite({
                        SourceId: item.SkillListings ?
                        item.BidId :
                        item.received.ProposalId,
                        SourceName: item.SkillListings ?
                        "Bid" :
                        "Proposal"
                      }));

                    }
                  }} /> :


                  <Rate
                  count="1"
                  onChange={(value) => {
                    if (value == 1) {
                      dispatch(
                      addMessageToFavourite({
                        SourceId: item.SkillListings ?
                        item.BidId :
                        item.received.ProposalId,
                        SourceName: item.SkillListings ?
                        "Bid" :
                        "Proposal"
                      }));

                    } else {
                      dispatch(
                      removeMessageFromFavourite({
                        SourceId: item.SkillListings ?
                        item.BidId :
                        item.received.ProposalId,
                        SourceName: item.SkillListings ?
                        "Bid" :
                        "Proposal"
                      }));

                    }
                  }} />}

                  
                        {/* <HistoryOutlined style={{ color: "#4054b2", fontSize: "4.5vw" }} /> */}
                        <CustomModal
                  status={item?.statuses?.BidStatusName}
                  history={{
                    createdDate: item?.bid_stages?.Created,
                    AcceptedDate: item?.bid_stages?.TalentReactOn,
                    profileSubmited: item?.bid_stages?.SubmittedOn,
                    interview: item?.bid_stages?.InterviewedOn,
                    interviewRejectOn:
                    item?.bid_stages?.InterviewedRejectOn,
                    offerAccepted: item?.bid_stages?.OfferReactOn,
                    BillingExpiredOn:
                    item?.bid_stages?.BillingExpiredOn,
                    BillingExtendOffOn:
                    item?.bid_stages?.BillingExtendOffOn,
                    BillingExtendedOn:
                    item?.bid_stages?.BillingExtendedOn,
                    BillingOffOn: item?.bid_stages?.BillingOffOn,
                    BillingOn: item?.bid_stages?.BillingOn,
                    CredentialingOn: item?.bid_stages?.CredentialingOn,
                    DropOutOn: item?.bid_stages?.DropOutOn,
                    HiredOn: item?.bid_stages?.HiredOn,
                    Modified: item?.bid_stages?.Modified,
                    OfferCreatedOn: item?.bid_stages?.OfferCreatedOn
                  }}
                  mobile={true} />
                  
                      </div>
                    </div>
                    <div className="Manage-candidate-bidCard-job-title-row">
                      <span
                onClick={(e) => {
                  e.stopPropagation();
                  history.push({
                    pathname: `/jobdetail/${item.gigs?.JobOrderId}`,
                    state: {
                      id: item.gigs?.JobOrderId
                    }
                  });
                }}>
                  
                        {item.gigs?.Title}
                      </span>
                    </div>
                    <div className="Manage-candidate-bidCard-facility-row">
                      <div className="Manage-candidate-bidCard-facility-name">
                        {item.gigs?.FacilityName || item?.FacilityName}
                        {item.gigs?.WorkplacePolicy}
                      </div>
                      <div className="Manage-candidate-bidCard-time">
                        <PlacedAndReceived bidType={item?.bidType} />
                      </div>
                    </div>
                    <div className="Manage-candidate-bidCard-facility-row">
                      <div className="Manage-candidate-bidCard-bidPlacedBy">
                        {item?.bidPlacedBy || item?.bidReceivedTo || "N/A"}
                      </div>
                      <div className="Manage-candidate-bidCard-time">
                        {item?.received ?
                  moment(item?.received?.Created).fromNow() :
                  moment(item?.Created).fromNow()}
                      </div>
                    </div>
                    <div className="Manage-candidate-status-btn-row">
                      <CustomDropdown
                status={item?.statuses?.BidStatusName}
                setStatusName={setBidStatusName}
                bidData={item}
                mobile={true}
                SkillListings={item.SkillListings} />
                
                      {/* <Dropdown overlay={statusCheck} className="drop1" trigger={['click']}>
                                          <Space style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                              <div className="Manage-candidate-status-text">{item.statuses}</div>&nbsp;
                                              <DownOutlined style={{ color: "#4e4e4e", fontSize: "2.5vw" }} />
                                          </Space>
                                      </Dropdown> */}
                    </div>
                  </div>);

        })}
          </div>
          {tableData.length != 0 ?
      <>
              <Pagination
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px"
        }}
        total={
        // all_bids_status ? (bidStatusName == "New_Bid" ?
        // all_bids_status[0]?.count
        // : bidStatusName == "Accepted_Bids" ?
        // all_bids_status[1]?.count
        // : bidStatusName == "Declined_Bids" ?
        // all_bids_status[2]?.count
        // : bidStatusName == "Retracted" ?
        // all_bids_status[17]?.count
        // : bidStatusName == "Profile_Submitted" ?
        // all_bids_status[3]?.count
        // : bidStatusName == "Interview_Proposed" ?
        // all_bids_status[4]?.count
        // : bidStatusName == "Interview_Accepted" ?
        // all_bids_status[5]?.count
        // : bidStatusName == "Interview_Cancelled" ?
        // all_bids_status[7]?.count
        // : bidStatusName == "Offer_Sent" ?
        // all_bids_status[8]?.count
        // : bidStatusName == "Offer_Accepted" ?
        // all_bids_status[9]?.count
        // : bidStatusName == "Offer_Declined" ?
        // all_bids_status[10]?.count
        // : bidStatusName == "Hired" ?
        // all_bids_status[11]?.count
        // : bidStatusName == "On_Billing" ?
        // all_bids_status[12]?.count
        // : bidStatusName == "Billing_Extended" ?
        // all_bids_status[13]?.count
        // : bidStatusName == "Off_Billing" ?
        // all_bids_status[14]?.count
        // : bidStatusName == "Terminated" ?
        // all_bids_status[15]?.count
        // :
        // bidStatusName == "Cancelled" &&
        // all_bids_status[16]?.count) :
        // 0
        result}

        current={page}
        defaultPageSize={perPage}
        onChange={(page) => onChangePage(page)}
        hideOnSinglePage={true}
        showSizeChanger={false} />
        
            </> :
      null}
        </div> :

    <>
          <div className="manageCandidateHeading">
            <div className="manageCandidateTitle">
              Candidate Tracking System{" "}
            </div>
          </div>
          {isPlanExpired ? (
            <FeatureGate
              featureName="Candidate Tracking System"
              iconType="candidate"
              description="Your free trial has ended. Choose a plan to continue managing and tracking the status of your talents."
              bottomText="Candidate Tracking System is a paid feature and was given to you for free during your trial period."
            />
          ) : false ? null : // (receivedBids?.length == 0) // (placedBids?.length == 0) && // (allBids?.length == 0) &&
      <div className="gridContainer">
              <div>
                <div className="searchCol">
                  <div className={inputFocused ? "hoveredSearch" : "search"}>
                    <div className="myInputAddon">
                      <SearchOutlined style={{ fontSize: "120%" }} />
                    </div>
                    <input
              className="myInput"
              placeholder="Search"
              value={searchText}
              onChange={(e) => onChangeSearch(e)}
              onKeyUp={onEnterSearch} />
              
                  </div>
                </div>
              </div>
              {profile?.MasterAccountId == null &&
        userProfile?.PvtEmpName !== "SG-PTM" &&
        ABS?.length > 0 ?
        <>
                  <ABSFilter
          disabled={isAbs}
          name={"All (ABS)"}
          dispatchFunction={absDetailInit}
          onSelect={handleSelectABS}
          value={absName}
          getFullName={(abs) =>
          getFullName(abs.ABSFirstName, abs.ABSLastName)} />

          
                  <ABSFilter
          disabled={isNull(absId)}
          name={"All"}
          dispatchFunction={getHRMDetailInit}
          isChild={true}
          onSelect={handleSelectHRM}
          value={HrmName}
          getFullName={(abs) =>
          getFullName(abs.FirstName, abs.LastName)}

          otherPayload={{ absAccountId: absId }}
          selectedAbs={{ id: absId, name: absName }} />
          
                </> :
        // <div className="col2 selectD">
        // <Select
        // className="drop1 "
        // dropdownStyle={{ zIndex: "999" }}
        // size={"small"}
        // defaultValue={HrmName}
        // onChange={handleMenuClick}
        // style={{
        // width: "93%",
        // display: "flex",
        // justifyContent: "center",
        // fontSize: "12px",
        // color: "#7e7e7e",
        // height: "27px",
        // alignItems: "center",
        // }}
        // options={details}
        // />
        // </div>
        profile?.MasterAccountId == null &&
        userProfile?.PvtEmpName == "SG-PTM" ?
        <ABSFilter
        // disabled={isNull(absId)}
        name={"All"}
        dispatchFunction={getHRMDetailInit}
        isChild={true}
        onSelect={handleSelectHRM}
        value={HrmName}
        getFullName={(abs) =>
        getFullName(abs.FirstName, abs.LastName)}

        otherPayload={{ absAccountId: absId }}
        selectedAbs={{ id: absId, name: absName }} /> :
        ''}
              <div>
                <div className="col2">
                  <Dropdown
            overlay={bidsStatusMenu}
            className="drop1"
            trigger={["click"]}
            overlayStyle={{ zIndex: "100" }}>
              
                    <Button
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center"
              }}>
                
                      {bidStatusName == "All" ?
                <div className="firstDropDownText">All</div> :
                bidStatusName == "New_Bid" ?
                <div className="firstDropDownText">New bids</div> :
                bidStatusName == "Accepted_Bids" ?
                <div className="firstDropDownText">Accepted bids</div> :
                bidStatusName == "Declined_Bids" ?
                <div className="firstDropDownText">Declined bids</div> :
                bidStatusName == "Retracted" ?
                <div className="firstDropDownText">Retracted bids</div> :
                bidStatusName == "Profile_Submitted" ?
                <div className="firstDropDownText">
                          Profile submitted
                        </div> :
                bidStatusName == "Interview_Proposed" ?
                <div className="firstDropDownText">
                          Interview proposed
                        </div> :
                bidStatusName == "Interview_Accepted" ?
                <div className="firstDropDownText">
                          Interview accepted
                        </div> :
                bidStatusName == "Interview_Cancelled" ?
                <div className="firstDropDownText">
                          Interview canceled
                        </div> :
                bidStatusName == "Offer_Sent" ?
                <div className="firstDropDownText">Offer sent</div> :
                bidStatusName == "Offer_Accepted" ?
                <div className="firstDropDownText">Offer accepted</div> :
                bidStatusName == "Offer_Declined" ?
                <div className="firstDropDownText">Offer declined</div> :
                bidStatusName == "Hired" ?
                <div className="firstDropDownText">Hired</div> :
                bidStatusName == "On_Billing" ?
                <div className="firstDropDownText">On billing</div> :
                bidStatusName == "Billing_Extended" ?
                <div className="firstDropDownText">
                          Billing extended
                        </div> :
                bidStatusName == "Off_Billing" ?
                <div className="firstDropDownText">Off billing</div> :
                bidStatusName == "Terminated" ?
                <div className="firstDropDownText">Terminated</div> :

                bidStatusName == "Cancelled" &&
                <div className="firstDropDownText">Canceled</div>}

                
                      <DownOutlined className="dropDownIcon" />
                    </Button>
                  </Dropdown>
                </div>
              </div>
              <div>
                <div className="col2">
                  <Dropdown
            overlay={bidsTypeMenu}
            className="drop1"
            trigger={["click"]}
            overlayStyle={{ zIndex: "100" }}>
              
                    <Button
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center"
              }}>
                
                      {bidTypeName == "All_Bids" ?
                <div className="firstDropDownText">All Bid Type</div> :
                bidTypeName == "Placed_Bid" ?
                <div className="firstDropDownText">Placed Bid</div> :
                bidTypeName == "Received_Bid" ?
                <div className="firstDropDownText">Received Bid</div> :

                bidTypeName == "Favorites" &&
                <div className="firstDropDownText">Favorites</div>}

                
                      <DownOutlined className="dropDownIcon" />
                    </Button>
                  </Dropdown>
                </div>
              </div>
              {userProfile?.PvtEmpName == "SG-PTM" &&
        <>
    <div className="col2">
      <Dropdown
            overlay={vmsMenu}
            className="drop1"
            trigger={["click"]}
            open={vmsDropdownOpen}
            onOpenChange={handleVmsOpenChange}>
              
        <Button
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center"
              }}>
                
          <div className="firstDropDownText">
            {getVmsDisplayNames(selectedVms)}
          </div>
          <DownOutlined className="dropDownIcon" />
        </Button>
      </Dropdown>
    </div>


    <div className="col2">
      <Dropdown
            overlay={facilityMenu}
            className="drop1"
            trigger={["click"]}
            open={facilityDropdownOpen}
            onOpenChange={handleFacilityOpenChange}>
              
        <Button
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center"
              }}>
                
          <div className="firstDropDownText">
            {getFacilityDisplayNames(selectedFacilities)}
          </div>
          <DownOutlined className="dropDownIcon" />
        </Button>
      </Dropdown>
    </div>
  </>}
        
              {/* FixMe */}
              {profile?.IsPrivateEmployer &&
        <div>
                  <div className="col2">
                    <Dropdown
            overlay={candidateTypeMenu}
            className="drop1"
            trigger={["click"]}
            overlayStyle={{ zIndex: "100" }}>
              
                      <Button
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center"
              }}>
                
                        <div className="firstDropDownText">
                          {candidateType == "private" ?
                  "Private candidates" :
                  "All candidates"}
                        </div>
                        <DownOutlined className="dropDownIcon" />
                      </Button>
                    </Dropdown>
                  </div>
                </div>}
        
              <div>
                <div className="col2">
                  <Dropdown
            overlay={timeSheetMenu}
            className="drop1"
            trigger={["click"]}
            overlayStyle={{ zIndex: "100" }}>
              
                    <Button
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center"
              }}>
                
                      <div className="firstDropDownText">
                        {TIME_SHEET_MENU_OPTIONS.find(
                  (el) => el.value == timeSheetType)?.
                  title || "All Timesheet"}
                      </div>
                      <DownOutlined className="dropDownIcon" />
                    </Button>
                  </Dropdown>
                </div>
              </div>
              <div
        className="range-picker"
        style={{ fontSize: "9px !important" }}>
          
                <RangePicker
          onFocus={() => {
            setDateFocussed(true);
          }}
          onBlur={() => {
            setDateFocussed(false);
          }}
          popupClassName="manage-candidate-date-range-picker"
          onChange={(e) => {
            if (e?.length > 0) {
              setStartDate(e[0]?.toDate().toISOString());
              setEndDate(e[1].toDate().toISOString());
              applyBidsFilters(
              bidTypeName,
              bidStatusName,
              HrmId,
              e[0]?.toDate().toISOString(),
              e[1].toDate().toISOString());

            } else if (e == null) {
              setStartDate("");
              setEndDate("");
            } else {
              setStartDate();
              setEndDate();
            }
          }}
          disabledDate={(current) => {
            return moment() < current;
          }}
          className={dateFocussed ? "hoveredDateRange" : "dateRange"}
          defaultValue={
          startDate != "" &&
          endDate != "" && [moment(startDate), moment(endDate)]}

          format={"DD/MM/YYYY"} />
          
              </div>
              <div>
                <div className="buttonsContainer">
                  <Button className="clearBtnNew" onClick={clearBidsFilters}>
                    Clear
                  </Button>
                </div>
              </div>
            </div>}
      
          <div className="bidResults">
            {
        // all_bids_status ? (bidStatusName == "New_Bid" ?
        // all_bids_status[0]?.count
        // : bidStatusName == "Accepted_Bids" ?
        // all_bids_status[1]?.count
        // : bidStatusName == "Declined_Bids" ?
        // all_bids_status[2]?.count
        // : bidStatusName == "Retracted" ?
        // all_bids_status[17]?.count
        // : bidStatusName == "Profile_Submitted" ?
        // all_bids_status[3]?.count
        // : bidStatusName == "Interview_Proposed" ?
        // all_bids_status[4]?.count
        // : bidStatusName == "Interview_Accepted" ?
        // all_bids_status[5]?.count
        // : bidStatusName == "Interview_Cancelled" ?
        // all_bids_status[7]?.count
        // : bidStatusName == "Offer_Sent" ?
        // all_bids_status[8]?.count
        // : bidStatusName == "Offer_Accepted" ?
        // all_bids_status[9]?.count
        // : bidStatusName == "Offer_Declined" ?
        // all_bids_status[10]?.count
        // : bidStatusName == "Hired" ?
        // all_bids_status[11]?.count
        // : bidStatusName == "On_Billing" ?
        // all_bids_status[12]?.count
        // : bidStatusName == "Billing_Extended" ?
        // all_bids_status[14]?.count
        // : bidStatusName == "Off_Billing" ?
        // all_bids_status[13]?.count
        // : bidStatusName == "Terminated" ?
        // all_bids_status[16]?.count
        // :
        // bidStatusName == "Cancelled" &&
        // all_bids_status[15]?.count) :
        // 0
        result}
        {" "}
            Results
          </div>
          {true ?
      <>
              {all_bids_status.length != 0 ?
        <Row className="cards" gutter={[0, 16]}>
                  {all_bids_status.length != 0 &&
          all_bids_status.map((item, index) => {
            if (index < 6) {
              return (
                <Col
                key={index}
                span={4}
                className="bidCardCol"
                xs={12}
                sm={8}
                md={8}
                xl={4}>
                  
                            <div
                  className="bidCard"
                  onClick={() => {
                    setBidStatusName(
                    item.title == "New" ?
                    "New_Bid" :
                    item.title == "Accepted" ?
                    "Accepted_Bids" :
                    item.title == "Declined" ?
                    "Declined_Bids" :
                    item.title == "ProfileSubmitted" ?
                    "Profile_Submitted" :
                    item.title == "Interview" ?
                    "Interview_Proposed" :
                    item.title == "InterviewAccepted" ?
                    "Interview_Accepted" :
                    "");

                    applyBidsFilters(
                    bidTypeName,
                    item.title == "New" ?
                    "New_Bid" :
                    item.title == "Accepted" ?
                    "Accepted_Bids" :
                    item.title == "Declined" ?
                    "Declined_Bids" :
                    item.title == "ProfileSubmitted" ?
                    "Profile_Submitted" :
                    item.title == "Interview" ?
                    "Interview_Proposed" :
                    item.title == "InterviewAccepted" ?
                    "Interview_Accepted" :
                    "",
                    HrmId,
                    startDate,
                    endDate);

                  }}>
                    
                              <p className="bidsCount">
                                {item.count == null ? 0 : item.count}
                              </p>
                              <p className="bidText">
                                {item.title === "New" ?
                      "New Bids" :
                      item.title === "InterviewAccepted" ?
                      "Interview Accepted" :
                      item.title === "ProfileSubmitted" ?
                      "Profile Submitted" :
                      item.title}
                              </p>
                            </div>
                          </Col>);

            }
          })}
                </Row> :
        null}
              {seeMore ?
        <>
                  {all_bids_status.length != 0 ?
          <>
                      <Row className="cards" gutter={[0, 16]}>
                        {all_bids_status.length != 0 &&
              all_bids_status.slice(6).map((item, index) =>
              <Col
              key={index}
              span={4}
              className="bidCardCol"
              xs={12}
              sm={8}
              md={8}
              xl={4}>
                
                              <div
                className="bidCard"
                onClick={() => {
                  setBidStatusName(
                  item.title == "InterviewCancelled" ?
                  "Interview_Cancelled" :
                  item.title == "Offer" ?
                  "Offer_Sent" :
                  item.title == "OfferAccepted" ?
                  "Offer_Accepted" :
                  item.title == "OfferDeclined" ?
                  "Offer_Declined" :
                  item.title == "Hired" ?
                  "Hired" :
                  item.title == "OnBilling" ?
                  "On_Billing" :
                  item.title == "OffBilling" ?
                  "Off_Billing" :
                  item.title == "BillingExtend" ?
                  "Billing_Extended" :
                  item.title == "Canceled" ?
                  "Cancelled" :
                  item.title == "Terminated" ?
                  "Terminated" :
                  item.title == "Retracted" ?
                  "Retracted" :
                  "",
                  HrmId,
                  startDate,
                  endDate);

                  applyBidsFilters(
                  bidTypeName,
                  item.title == "InterviewCancelled" ?
                  "Interview_Cancelled" :
                  item.title == "Offer" ?
                  "Offer_Sent" :
                  item.title == "OfferAccepted" ?
                  "Offer_Accepted" :
                  item.title == "OfferDeclined" ?
                  "Offer_Declined" :
                  item.title == "Hired" ?
                  "Hired" :
                  item.title == "OnBilling" ?
                  "On_Billing" :
                  item.title == "OffBilling" ?
                  "Off_Billing" :
                  item.title == "BillingExtend" ?
                  "Billing_Extended" :
                  item.title == "Canceled" ?
                  "Cancelled" :
                  item.title == "Terminated" ?
                  "Terminated" :
                  item.title == "Retracted" ?
                  "Retracted" :
                  "",
                  HrmId,
                  startDate,
                  endDate);

                }}>
                  
                                <p className="bidsCount">
                                  {item.count == null ? 0 : item.count}
                                </p>
                                <p className="bidText">
                                  {{
                      InterviewCancelled: "Interview Cancelled",
                      OfferAccepted: "Offer Accepted",
                      OfferDeclined: "Offer Declined",
                      OnBilling: "On Billing",
                      OffBilling: "Off Billing",
                      BillingExtend: "Billing Extend"
                    }[item.title] || item.title}
                                </p>
                              </div>
                            </Col>)}
              
                      </Row>
                      {!isRestrictedPlan && <Row className="cards" gutter={[0, 16]}>
                        <Col span={24}>
                          <div className="manageTimesheetHeading">
                            <div className="manageCandidateTitle">
                              Timesheet Management{" "}
                            </div>
                          </div>
                        </Col>
                        {TIME_SHEET_MENU_OPTIONS.slice(2).map(
              (timeSheetOption) =>
              <Col
              span={4}
              className="bidCardCol"
              xs={12}
              sm={8}
              md={8}
              xl={4}
              onClick={() =>
              handleTimeSheetChange(timeSheetOption.value)}>


                              <div className="bidCard">
                                <p className="bidsCount">
                                  {bid_types_count?.[timeSheetOption?.key] || 0}
                                </p>
                                <p className="bidText">
                                  {timeSheetOption.title}
                                </p>
                              </div>
                            </Col>)}
                      </Row>}

                        {/* <Col
                span={4}
                className="bidCardCol"
                xs={12}
                sm={8}
                md={8}
                xl={4}
                >
                <div className="bidCard">
                <p className="bidsCount">0</p>
                <p className="bidText">{"Time Off Request"}</p>
                </div>
                </Col> */}
                    </> :
          null}
                </> :
        null}
              <p
        onClick={() => {
          setSeeMore((p) => !p);
        }}
        className="seeMore">
          
                {seeMore ? "See less" : "See more"}
              </p>
              {loading || hireLoading ? null : allBids?.length ==
        tableData?.length ||
        receivedBids?.length == tableData?.length ||
        placedBids?.length == tableData?.length ||
        favouriteBids?.length == tableData?.length ||
        tableData?.length < allBids?.length ||
        tableData?.length < receivedBids?.length ||
        tableData?.length < placedBids?.length ||
        tableData?.length < favouriteBids?.length ?
        <div className="tableContainer">
                  <Table
          className="table"
          columns={columns}
          dataSource={tableData}
          onChange={onChange}
          pagination={false} />
          
                </div> :
        null}
              {tableData.length != 0 ?
        <>
                  <Pagination
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px"
          }}
          total={result}
          current={page}
          defaultPageSize={perPage}
          onChange={(page) => onChangePage(page)}
          hideOnSinglePage={true}
          showSizeChanger={false} />
          
                </> :
        null}
            </> :

      <div className="noJobsContainer">
              <img
        src={emptyjobs}
        alt="no-jobsimg"
        className="joblisting-noimg"
        style={{ width: "15rem", height: "9.3rem" }}>
        </img>
              {/* <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '0.5rem',
          fontSize: '16px'}}>No data</div> */}
            </div>}
      
          {loading || hireLoading ? null : allBids?.length ==
      tableData?.length ||
      receivedBids?.length == tableData?.length ||
      placedBids?.length == tableData?.length ||
      favouriteBids?.length == tableData?.length ||
      tableData?.length < allBids?.length ||
      tableData?.length < receivedBids?.length ||
      tableData?.length < placedBids?.length ||
      tableData?.length < favouriteBids?.length ?
      <div className="tableContainer"></div> :
      null}
        </>}
    
    </div>;

}
